module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-5-Landing-Page.ba72b1d7.jpg";